export const translations = {
  de: {
    nav: {
      tickets: "Tickets",
      booths: "Standmiete",
      about: "Über",
      faq: "FAQ",
      contact: "Kontakt",
      hallenplan: "Hallenplan",
      exhibitors: "Aussteller",
      cta: "Ticket sichern",
    },
    hero: {
      date_chip: "06 · 09 · 2026",
      location_chip: "Halle Tor 2 · Köln",
      title_part1: "Pulls. Trades. Grails.",
      title_part2: "Köln, 06.09.2026.",
      subtitle:
        "Sammelkarten. Sportkarten. Grading, Trades und die seltensten Karten Europas — an einem Tag, an einem Ort. Cologne Card Con bringt Fans, Händler und Sammler in der Halle Tor 2 zusammen.",
      cta_tickets: "Tickets sichern",
      cta_booths: "Stand mieten",
      stat_exhibitors: "Aussteller",
      stat_sqm: "Quadratmeter",
      stat_categories: "Hauptkategorien",
      stat_visitors: "Besucher erwartet",
      meta_date: "Sonntag, 06. September 2026 · 10:00–18:00",
      meta_address: "Halle Tor 2 · Girlitzweg 30, 50829 Köln",
      meta_categories: "Pokémon · Magic · Yu-Gi-Oh! · One Piece · NBA · NFL · Soccer",
    },
    about: {
      eyebrow: "Was dich erwartet",
      title_l1: "Eine Halle.",
      title_l2: "Ein Tag.",
      title_l3: "Unendlich viele Karten.",
      body: "Die Cologne Card Con ist Kölns neuer Treffpunkt für die Sammelkarten- und Sportkartenszene. Über 80 Aussteller, dutzende Side Events und ein Programm, das von 10 bis 18 Uhr keine Sekunde Pause macht. Egal ob du deine erste Karte holst oder deine Sammlung um eine PSA 10 erweiterst — hier findest du, was du suchst.",
      features: [
        { title: "Seltene Karten", text: "Vom Charizard 1st Edition bis zu Rookie-Patches. Top-Dealer aus ganz Europa unter einem Dach." },
        { title: "Trading Area", text: "Tausche, handle und finde fehlende Karten an offenen Trading-Tischen mitten in der Halle." },
        { title: "Singles & Sealed", text: "Vom Einzelkauf bis zur versiegelten Display-Box — riesige Auswahl für jeden Geldbeutel." },
        { title: "PGS Grading-Annahme", text: "PGS ist vor Ort: kostenlose Pre-Grading-Sichtung und Annahme deiner Karten fürs Grading. Die Bewertung erfolgt im Anschluss." },
      ],
    },
    tickets: {
      eyebrow: "01 — Tickets",
      title: "Sichere dir deinen Platz auf der Messe.",
      subtitle:
        "Drei Ticketkategorien, ein Tag voller Karten. Einlass für alle ab 10:00 Uhr, Familien sparen 12€.",
      early_badge: "BELIEBT",
      cart: "Warenkorb",
      ticket_single: "Ticket",
      ticket_plural: "Tickets",
      checkout: "Zur Kasse",
      dialog_title: "Fast geschafft",
      dialog_desc: "Bestellung über {amount} · sichere Zahlung mit Stripe",
      name: "Name",
      email: "E-Mail",
      name_ph: "Max Mustermann",
      email_ph: "max@example.de",
      pay: "Sicher bezahlen",
      preparing: "Wird vorbereitet...",
      err_no_tickets: "Wähle mindestens ein Ticket aus.",
      err_no_contact: "Bitte Name und E-Mail eingeben.",
    },
    booths: {
      eyebrow: "02 — Standmiete",
      title: "Werde Aussteller. Verkaufe. Connecte.",
      subtitle:
        "Vier Standgrößen. Strom, Tische und Stühle inklusive. Aufbau Samstag ab 16 Uhr, Abbau Sonntag ab 18 Uhr. Sichere dir deinen Platz direkt online.",
      popular: "BELIEBT",
      avail_left: "Noch {n} verfügbar",
      sold_out: "Ausverkauft",
      book: "Stand buchen",
      pick_on_map: "Platz im Hallenplan wählen",
      map_hint: "Klicke unten im Hallenplan auf einen freien Stand, um zu buchen.",
      dialog_title: "{name} buchen",
      company: "Firma / Shop *",
      contact: "Ansprechpartner *",
      email: "E-Mail *",
      phone: "Telefon *",
      products: "Was verkaufst du? *",
      products_ph: "z.B. Pokémon Singles, Slabs, Sealed Product",
      notes: "Besondere Wünsche",
      pay_secure: "{amount} sicher bezahlen",
      preparing: "Wird vorbereitet...",
      err_fields: "Bitte alle Pflichtfelder ausfüllen.",
    },
    hallenplan: {
      eyebrow: "Hallenplan",
      title: "So findest du dich zurecht.",
      title_interactive: "Wähle deinen Stand auf dem Hallenplan.",
      subtitle:
        "Halle Tor 2 wird in vier Zonen aufgeteilt — von Premium-Ecken am Haupteingang bis zur Trading Lounge im Zentrum.",
      subtitle_interactive:
        "Grüne Felder sind frei, orange Felder bereits reserviert, graue Felder vergeben. Klicke auf ein freies Feld, um direkt zu buchen.",
      subtitle_multi:
        "Klicke ein oder mehrere grüne Felder an, um sie zum Warenkorb hinzuzufügen. Bezahle alle ausgewählten Stände in einer Stripe-Transaktion.",
      status_available: "Frei",
      status_selected: "Ausgewählt",
      status_reserved: "Reserviert",
      status_taken: "Vergeben",
      cart_title: "Deine Auswahl",
      cart_empty: "Noch nichts ausgewählt — klicke auf einen grünen Stand.",
      total: "Gesamt",
      clear: "Leeren",
      go_checkout: "Zur Kasse ({n})",
      checkout_title: "{n} Stände buchen",
      book_title: "Stand {slot} buchen · {tier}",
      toast_taken: "Dieser Stand ist bereits vergeben.",
      toast_reserved: "Dieser Stand ist gerade in Buchung.",
      toast_max: "Maximal 6 Stände pro Buchung.",
      zones: {
        premium: { label: "Premium", desc: "Eckstände am Haupteingang" },
        large: { label: "Large", desc: "Galerie an den Längsseiten" },
        medium: { label: "Medium", desc: "Innere Hauptachse" },
        small: { label: "Small", desc: "Außenringe & Side Aisles" },
        stage: { label: "Mainstage", desc: "Breaks, Auktionen, Meet & Greet" },
        lounge: { label: "Trade Lounge", desc: "Speed-Trade-Tische" },
      },
      entry: "Haupteingang",
      exit: "Notausgang",
    },
    exhibitors: {
      eyebrow: "04 — Aussteller",
      title: "80+ Händler. Eine Halle. Dein Grail wartet.",
      subtitle:
        "Von Pokémon-Boutiquen bis zu Grading-Häusern: das sind die Aussteller, die deinen Sammeltag zum Highlight machen.",
      all: "Alle",
      empty: "Für diese Kategorie sind noch keine Aussteller gelistet.",
      cta_hint: "Du willst selbst dabei sein?",
      cta_link: "Sichere dir jetzt einen Stand →",
    },
    faq: {
      eyebrow: "Häufige Fragen",
      title: "Alles, was du wissen musst.",
      items: [
        { q: "Wann und wo findet die Cologne Card Con statt?", a: "Am Sonntag, den 06. September 2026 von 10:00 bis 18:00 Uhr in der Halle Tor 2, Girlitzweg 30, 50829 Köln. Einlass für Besucher ab 10:00 Uhr." },
        { q: "Welche Kartenkategorien sind vertreten?", a: "Pokémon, Magic: The Gathering, One Piece, Lorcana, Yu-Gi-Oh!, sowie Sportkarten aus NBA, NFL, MLB, Soccer und Formel 1. Daneben Slabs (PSA/BGS/SGC), Memorabilia und Singles." },
        { q: "Wie funktioniert der Ticketkauf?", a: "Tickets werden direkt online über sichere Stripe- oder PayPal-Zahlung gekauft. Nach erfolgreicher Zahlung erhältst du eine Bestätigung mit Ticket-PDF und Rechnung per E-Mail. Am Einlass genügt dein Ticket bzw. die Bestellnummer." },
        { q: "Kann ich einen Stand als Aussteller buchen?", a: "Ja! Im Bereich „Standmiete“ kannst du zwischen vier Standgrößen wählen und direkt online buchen. Nach der Zahlung melden wir uns innerhalb von 48 Stunden mit allen Aufbauinformationen." },
        { q: "Gibt es Parkplätze oder ÖPNV-Anbindung?", a: "Die Halle Tor 2 bietet kostenpflichtige Parkplätze direkt am Gelände. Mit der KVB Linie 5 (Haltestelle Ossendorf) bist du in 8 Minuten vom Hauptbahnhof am Ort." },
        { q: "Werden Karten an Minderjährige verkauft?", a: "Kinder bis 5 Jahre haben freien Eintritt, von 6 bis 13 Jahren gilt das Kinderticket. Trading-Events ab 14 Jahren benötigen Begleitung durch einen Erziehungsberechtigten." },
      ],
    },
    contact: {
      eyebrow: "03 — Kontakt",
      title: "Frage? Pressestelle? Sponsor?",
      subtitle:
        "Schreib uns — wir antworten meistens innerhalb von 24 Stunden. Für Aussteller-Anfragen nutze direkt die Buchung oben.",
      email_label: "E-Mail",
      phone_label: "Telefon",
      addr_label: "Anschrift",
      name: "Name",
      email: "E-Mail",
      subject: "Betreff",
      message: "Nachricht",
      send: "Senden",
      sending: "Wird gesendet...",
      sent: "Gesendet ✓",
      err_fill: "Bitte alle Felder ausfüllen.",
      ok: "Nachricht gesendet!",
      err_send: "Fehler beim Senden",
    },
    footer: {
      blurb:
        "Die Messe für Sammelkarten- und Sportkarten-Fans in Köln. Pokémon, Magic, Yu-Gi-Oh!, One Piece, NBA, NFL, Fußball — alles unter einem Dach.",
      event: "Event",
      contact: "Kontakt",
      copyright: "© 2026 Cologne Card Con · Alle Rechte vorbehalten",
      legal: "Impressum · Datenschutz · AGB",
      tickets_link: "Tickets",
      booths_link: "Standmiete",
      admin: "Aussteller-Login",
    },
    success: {
      polling_title: "Zahlung wird geprüft...",
      polling_sub: "Bitte schließe dieses Fenster nicht.",
      paid_title: "Vielen Dank!",
      paid_sub: "Deine Zahlung ist eingegangen. Eine Bestätigung kommt per E-Mail.",
      order: "Bestellung",
      booking: "Standbuchung",
      back: "Zur Startseite",
      err_title: "Status unklar",
      expired_title: "Sitzung abgelaufen",
      err_sub: "Wir konnten den Zahlungsstatus nicht final bestätigen. Bei Fragen melde dich unter hallo@colognecardcon.de.",
      back_alt: "Zurück zur Startseite",
    },
    cancel: {
      title: "Zahlung abgebrochen",
      sub: "Keine Sorge — es wurde nichts abgebucht. Du kannst es jederzeit erneut versuchen.",
      back: "Zurück zu den Tickets",
    },
    admin: {
      login_title: "Anmelden",
      login_eyebrow: "Administration",
      password: "Passwort",
      submit: "Anmelden",
      submitting: "Anmelden...",
      stats_revenue: "Umsatz Gesamt",
      stats_tickets_sold: "Tickets verkauft",
      stats_booths_booked: "Stände gebucht",
      stats_booth_revenue: "Standmieten",
      tab_orders: "Ticketbestellungen",
      tab_booths: "Standbuchungen",
      tab_messages: "Nachrichten",
      tab_exhibitors: "Aussteller",
      th_date: "Datum",
      th_customer: "Kunde",
      th_tickets: "Tickets",
      th_amount: "Betrag",
      th_status: "Status",
      th_company: "Firma",
      th_contact: "Kontakt",
      th_booth: "Stand",
      empty_orders: "Noch keine Bestellungen.",
      empty_booths: "Noch keine Standbuchungen.",
      empty_messages: "Keine Nachrichten.",
      logout: "Logout",
      export: "CSV Export",
    },
  },
  en: {
    nav: {
      tickets: "Tickets",
      booths: "Exhibitors",
      about: "About",
      faq: "FAQ",
      contact: "Contact",
      hallenplan: "Floor plan",
      exhibitors: "Vendors",
      cta: "Get tickets",
    },
    hero: {
      date_chip: "06 · 09 · 2026",
      location_chip: "Halle Tor 2 · Cologne",
      title_part1: "Pulls. Trades. Grails.",
      title_part2: "Cologne, 09.06.2026.",
      subtitle:
        "Trading cards. Sports cards. Grading, trades and Europe's rarest cards — one day, one place. Cologne Card Con brings fans, dealers and collectors together in Halle Tor 2.",
      cta_tickets: "Get tickets",
      cta_booths: "Rent a booth",
      stat_exhibitors: "Exhibitors",
      stat_sqm: "Square meters",
      stat_categories: "Main categories",
      stat_visitors: "Expected visitors",
      meta_date: "Sunday, Sept 6, 2026 · 10:00–18:00",
      meta_address: "Halle Tor 2 · Girlitzweg 30, 50829 Cologne",
      meta_categories: "Pokémon · Magic · Yu-Gi-Oh! · One Piece · NBA · NFL · Soccer",
    },
    about: {
      eyebrow: "What to expect",
      title_l1: "One hall.",
      title_l2: "One day.",
      title_l3: "Endless cards.",
      body: "Cologne Card Con is the new home of Europe's trading and sports card scene. 80+ exhibitors, dozens of side events and a program that never stops from 10am to 6pm. Whether you grab your first card or hunt for a PSA 10 — you will find it here.",
      features: [
        { title: "Rare cards", text: "From 1st Edition Charizard to rookie patches. Top dealers from across Europe under one roof." },
        { title: "Trading Area", text: "Trade, deal and hunt down missing cards at open trading tables right in the hall." },
        { title: "Singles & Sealed", text: "From single cards to sealed display boxes — a huge selection for every budget." },
        { title: "PGS grading drop-off", text: "PGS on site: free pre-grading check and card intake for grading. The grading itself happens afterwards." },
      ],
    },
    tickets: {
      eyebrow: "01 — Tickets",
      title: "Secure your spot at the show.",
      subtitle: "Three ticket tiers, one day full of cards. Doors open for everyone at 10:00, families save €12.",
      early_badge: "POPULAR",
      cart: "Cart",
      ticket_single: "Ticket",
      ticket_plural: "Tickets",
      checkout: "Checkout",
      dialog_title: "Almost there",
      dialog_desc: "Order for {amount} · secured by Stripe",
      name: "Name",
      email: "Email",
      name_ph: "Jane Doe",
      email_ph: "jane@example.com",
      pay: "Pay securely",
      preparing: "Preparing...",
      err_no_tickets: "Please select at least one ticket.",
      err_no_contact: "Please enter name and email.",
    },
    booths: {
      eyebrow: "02 — Booth rental",
      title: "Become an exhibitor. Sell. Connect.",
      subtitle: "Four booth sizes. Power, tables and chairs included. Set up Saturday from 4pm, tear down Sunday from 6pm. Book your spot online.",
      popular: "POPULAR",
      avail_left: "{n} left",
      sold_out: "Sold out",
      book: "Book this booth",
      pick_on_map: "Pick a spot on the floor plan",
      map_hint: "Scroll down to the floor plan and click any green slot to book.",
      dialog_title: "Book {name}",
      company: "Company / Shop *",
      contact: "Contact name *",
      email: "Email *",
      phone: "Phone *",
      products: "What do you sell? *",
      products_ph: "e.g. Pokémon singles, slabs, sealed product",
      notes: "Special requests",
      pay_secure: "Pay {amount} securely",
      preparing: "Preparing...",
      err_fields: "Please fill in all required fields.",
    },
    hallenplan: {
      eyebrow: "Floor plan",
      title: "How to find your way around.",
      title_interactive: "Pick your booth on the floor plan.",
      subtitle: "Halle Tor 2 is divided into four zones — from premium corners at the main entrance to the trading lounge in the center.",
      subtitle_interactive: "Green slots are free, orange slots are being reserved, gray slots are taken. Click a green slot to book it instantly.",
      subtitle_multi: "Click one or more green slots to add them to your cart. Pay for all selected booths in a single Stripe transaction.",
      status_available: "Free",
      status_selected: "Selected",
      status_reserved: "Reserved",
      status_taken: "Taken",
      cart_title: "Your selection",
      cart_empty: "Nothing selected yet — click any green slot.",
      total: "Total",
      clear: "Clear",
      go_checkout: "Checkout ({n})",
      checkout_title: "Book {n} booths",
      book_title: "Book slot {slot} · {tier}",
      toast_taken: "This slot is already taken.",
      toast_reserved: "This slot is currently being booked.",
      toast_max: "Maximum 6 booths per booking.",
      zones: {
        premium: { label: "Premium", desc: "Corner booths near main entry" },
        large: { label: "Large", desc: "Gallery along the long sides" },
        medium: { label: "Medium", desc: "Central main aisle" },
        small: { label: "Small", desc: "Outer rings & side aisles" },
        stage: { label: "Main stage", desc: "Breaks, auctions, meet & greet" },
        lounge: { label: "Trade lounge", desc: "Speed-trade tables" },
      },
      entry: "Main entrance",
      exit: "Emergency exit",
    },
    exhibitors: {
      eyebrow: "04 — Vendors",
      title: "80+ dealers. One hall. Your grail is waiting.",
      subtitle: "From Pokémon boutiques to grading houses — these are the vendors that turn your day into the highlight of the year.",
      all: "All",
      empty: "No vendors listed in this category yet.",
      cta_hint: "Want to be on this list?",
      cta_link: "Book a booth →",
    },
    faq: {
      eyebrow: "Frequently asked",
      title: "Everything you need to know.",
      items: [
        { q: "When and where is Cologne Card Con?", a: "Sunday, September 6, 2026 from 10:00 to 18:00 at Halle Tor 2, Girlitzweg 30, 50829 Cologne. Doors open for visitors at 10:00." },
        { q: "Which card categories are on site?", a: "Pokémon, Magic: The Gathering, One Piece, Lorcana, Yu-Gi-Oh!, and sports cards across NBA, NFL, MLB, soccer and F1. Plus slabs (PSA/BGS/SGC), memorabilia and singles." },
        { q: "How does ticket purchase work?", a: "Tickets are bought online via secure Stripe checkout. After successful payment you receive a confirmation with your order ID. That ID is all you need at the door." },
        { q: "Can I book a booth as an exhibitor?", a: "Yes! Under 'Exhibitors' you can pick from four sizes and book online. After payment, we get back to you within 48 hours with set-up details." },
        { q: "Parking and public transport?", a: "Paid parking is available next to Halle Tor 2. Tram line 5 (stop Ossendorf) reaches the venue in 8 minutes from Cologne main station." },
        { q: "Are cards sold to minors?", a: "Kids up to 5 enter free, ages 6–13 need the kids ticket. Trading events require accompanying adult under 14." },
      ],
    },
    contact: {
      eyebrow: "03 — Contact",
      title: "Question? Press? Sponsor?",
      subtitle: "Drop us a line — we typically reply within 24 hours. For exhibitor inquiries please use the booking form above.",
      email_label: "Email",
      phone_label: "Phone",
      addr_label: "Address",
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      send: "Send",
      sending: "Sending...",
      sent: "Sent ✓",
      err_fill: "Please fill in all fields.",
      ok: "Message sent!",
      err_send: "Failed to send",
    },
    footer: {
      blurb:
        "The trading and sports card convention for Cologne. Pokémon, Magic, Yu-Gi-Oh!, One Piece, NBA, NFL, soccer — all under one roof.",
      event: "Event",
      contact: "Contact",
      copyright: "© 2026 Cologne Card Con · All rights reserved",
      legal: "Imprint · Privacy · Terms",
      tickets_link: "Tickets",
      booths_link: "Exhibitors",
      admin: "Exhibitor login",
    },
    success: {
      polling_title: "Verifying payment...",
      polling_sub: "Please don't close this window.",
      paid_title: "Thank you!",
      paid_sub: "Your payment was received. A confirmation will follow by email.",
      order: "Order",
      booking: "Booth booking",
      back: "Back to home",
      err_title: "Status unclear",
      expired_title: "Session expired",
      err_sub: "We could not confirm the payment status. For questions reach us at hallo@colognecardcon.de.",
      back_alt: "Back to home",
    },
    cancel: {
      title: "Payment cancelled",
      sub: "No worries — you weren't charged. Feel free to try again.",
      back: "Back to tickets",
    },
    admin: {
      login_title: "Sign in",
      login_eyebrow: "Administration",
      password: "Password",
      submit: "Sign in",
      submitting: "Signing in...",
      stats_revenue: "Total revenue",
      stats_tickets_sold: "Tickets sold",
      stats_booths_booked: "Booths booked",
      stats_booth_revenue: "Booth revenue",
      tab_orders: "Ticket orders",
      tab_booths: "Booth bookings",
      tab_messages: "Messages",
      tab_exhibitors: "Vendors",
      th_date: "Date",
      th_customer: "Customer",
      th_tickets: "Tickets",
      th_amount: "Amount",
      th_status: "Status",
      th_company: "Company",
      th_contact: "Contact",
      th_booth: "Booth",
      empty_orders: "No orders yet.",
      empty_booths: "No booth bookings yet.",
      empty_messages: "No messages.",
      logout: "Logout",
      export: "CSV export",
    },
  },
};
